import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-114d80b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"80vh","overflow":"auto"} }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center h-600px"
}
const _hoisted_3 = {
  key: 1,
  style: {"position":"relative"}
}
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = { class: "d-flex justify-content-end" }

import {
  ref,
  provide,
  reactive,
  nextTick,
  inject,
  computed,
  onMounted,
} from "vue";
import ModalMenu from "./jpVerifyModal/ModalMenu.vue";
import JpInfo from "./jpVerifyModal/JpInfo.vue";
import JpFinancial from "./jpVerifyModal/JpFinancial.vue";
import JpAgreement from "./jpVerifyModal/JpAgreement.vue";
import JpReview from "./jpVerifyModal/JpReview.vue";
import JpPdf from "./jpVerifyModal/JpPdf.vue";
import JpVerificationCode from "./jpVerifyModal/JpVerificationCode.vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import type { FormInstance } from "element-plus";
import html2pdf from "html2pdf.js";
import notification from "@/core/plugins/notification";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import { VerificationStatusTypes } from "@/core/types/VerificationInfos";
import { ElNotification } from "element-plus";
import i18n from "@/core/plugins/i18n";
import ShowMoveModal from "@/projects/tenant/modules/accounts/components/modal/ShowMoveModal.vue";
import { useStore } from "@/store";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import { getJpAccountType } from "@/core/types/jp/verificationFinancial";


export default /*#__PURE__*/_defineComponent({
  __name: 'jpVerifyModal',
  emits: ["fetch-data", "user-moved"],
  setup(__props, { expose: __expose, emit: emits }) {

const t = i18n.global.t;
const VerificationTab = {
  Info: "Info",
  Financial: "Financial",
  Agreement: "Agreement",
  Review: "Review",
  PDF: "PDF",
  VerificationCode: "VerificationCode",
};

const currentTab = ref(VerificationTab.PDF);
const verificationDetails = ref<any>({});
const isLoading = ref(false);
const disabled = ref(false);
const isPrinting = ref(false);
const formData = ref<any>({});
const store = useStore();
const user = store.state.AuthModule.user;
const userName = ref("");
const verificationId = ref(0);
const partyId = ref(0);
const code = ref("〇〇〇〇");

provide("code", code);
provide("disabled", disabled);
provide("isLoading", isLoading);
provide("currentTab", currentTab);
provide("VerificationTab", VerificationTab);
provide("verificationDetails", verificationDetails);
provide("formData", formData);

const dialogRef = ref(false);
const ruleFormRef = ref<FormInstance>();
const rules = reactive<any>({});



const convertToPdf = async () => {
  currentTab.value = VerificationTab.PDF;
  await nextTick();
  isPrinting.value = true;
  try {
    const element = document.getElementById("print") as HTMLElement;
    const opt = {
      margin: [1, 0.2],
      filename: `Verification ${userName.value}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, logging: true },
      jsPDF: { unit: "in", format: "a3", orientation: "portrait" },
    };
    await html2pdf().from(element).set(opt).save();
    notification.success();
  } catch (error) {
    console.log("error", error);
    notification.danger();
  } finally {
    isPrinting.value = false;
  }
};

const downloadCode = async () => {
  currentTab.value = VerificationTab.VerificationCode;
  await nextTick();
  isPrinting.value = true;
  try {
    const element = document.getElementById("print") as HTMLElement;
    const opt = {
      margin: [0.5, 0.2],
      filename: `Code ${userName.value}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, logging: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    await html2pdf().from(element).set(opt).save();
    notification.success();
  } catch (error) {
    console.log("error", error);
    notification.danger();
  } finally {
    isPrinting.value = false;
  }
};

const generateCode = async () => {
  isLoading.value = true;

  try {
    await UserService.putUserToAwaitingCodeVerify(verificationId.value);
    await UserService.generateMailCode(verificationDetails.value.id);
    await nextTick();
    currentTab.value = VerificationTab.VerificationCode;
  } catch (error) {
    console.log("error", error);
    notification.danger();
  } finally {
    isLoading.value = false;
  }
};

const loadUserVerifications = async (id) => {
  try {
    isLoading.value = true;
    verificationDetails.value = await UserService.getVerificationById(id);
    var info = verificationDetails.value.info;
    userName.value = info.firstName + " " + info.lastName;
    verificationId.value = verificationDetails.value.id;
    partyId.value = verificationDetails.value.partyId;
    changeCurrentTab();
  } catch (error) {
    console.log("error", error);
    notification.danger();
  } finally {
    isLoading.value = false;
  }
};

const changeCurrentTab = () => {
  if (
    verificationDetails.value.status ===
    VerificationStatusTypes.AwaitingCodeVerify
  ) {
    currentTab.value = VerificationTab.VerificationCode;
  }
};

const openConfirmModal = inject<any>(
  TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL
);

const moveModalRef = ref<InstanceType<typeof ShowMoveModal>>();
const showMoveModal = () => {
  moveModalRef.value?.show(verificationDetails.value.partyId, user);
};

const openConfirmPanel = (_action: VerificationStatusTypes) => {
  openConfirmModal?.(() => {
    return {
      [VerificationStatusTypes.AwaitingAddressVerify]: () =>
        UserService.putUserToAwaitingVerify(verificationId.value),

      [VerificationStatusTypes.AwaitingCodeVerify]: () => generateCode(),

      [VerificationStatusTypes.Approved]: () =>
        UserService.putUserToApproved(verificationId.value),

      [VerificationStatusTypes.Rejected]: () => rejectVerification(),
    }
      [_action]()
      .then(() => {
        verificationDetails.value.status = _action;
        ElNotification({
          title: t("status.success"),
          message: t("status.success"),
          type: "success",
        });
        emits("fetch-data");
      });
  });
};

const buttonConfigs = computed(() => [
  {
    label: t("action.sendIdVerification"),
    type: "primary",
    show: [VerificationStatusTypes.AwaitingReview],
    action: () =>
      openConfirmPanel(VerificationStatusTypes.AwaitingAddressVerify),
  },

  {
    label: t("action.generateCode"),
    type: "warning",
    show: [VerificationStatusTypes.AwaitingAddressVerify],
    action: () => openConfirmPanel(VerificationStatusTypes.AwaitingCodeVerify),
  },
  {
    label: t("action.approve"),
    type: "success",
    show: [],
    action: () => approveAndCreateApplications(),
  },
  {
    label: t("action.reject"),
    type: "danger",
    show: [
      VerificationStatusTypes.AwaitingReview,
      VerificationStatusTypes.AwaitingAddressVerify,
    ],
    action: () => openConfirmPanel(VerificationStatusTypes.Rejected),
  },
]);

const approveAndCreateApplications = async () => {
  isLoading.value = true;
  try {
    await UserService.putUserToApproved(verificationId.value);
    await createApplications();
    // emits("fetch-data");
  } catch (error) {
    console.log("error", error);
    notification.danger();
  } finally {
    isLoading.value = false;
  }
};

const createApplications = async () => {
  try {
    var accountTypes = verificationDetails.value.financial.accountTypes;
    var accountRole = verificationDetails.value.financial.accountRole;
    console.log("account Types : ", accountTypes);
    console.log("account Role : ", accountRole);
    await accountTypes.forEach((accountType) => {
      var jpAccountType = getJpAccountType(accountRole, accountType);
      console.log("jpAccountType : ", jpAccountType);
      var applicationData = {
        accountType: jpAccountType,
        currencyId: 392,
        leverage: 20,
        serviceId: 30,
        platform: 30,
      };
      UserService.openTradeAccount(
        verificationDetails.value.partyId,
        applicationData
      );
    });
    notification.success();
    emits("fetch-data");
  } catch (error) {
    console.log("error", error);
    notification.danger();
  } finally {
    isLoading.value = false;
  }
};

const rejectVerification = async () => {
  isLoading.value = true;
  try {
    await UserService.putUserToRejected(verificationId.value);
    await UserService.sendRejectDocumentEmail(verificationId.value);
    ElNotification.success(t("tip.emailSent"));
    emits("fetch-data");
  } catch (error) {
    console.log("error", error);
    notification.danger();
  } finally {
    isLoading.value = false;
  }
};
const show = async (id: number) => {
  dialogRef.value = true;
  await loadUserVerifications(id);
};

const hide = () => {
  dialogRef.value = false;
  currentTab.value = VerificationTab.PDF;
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: dialogRef.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogRef).value = $event)),
      title: 
      _ctx.$t('title.verifications') + ' - ' + userName.value + ' - ' + verificationId.value
    ,
      width: "1100",
      "align-center": "",
      "before-close": hide
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            (_ctx.$can('SuperAdmin'))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "warning",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showMoveModal()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.moveUser")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (convertToPdf())),
              disabled: isLoading.value,
              loading: isPrinting.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.downloadPdf")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading"]),
            (code.value && code.value !== '〇〇〇〇')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "info",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (downloadCode())),
                  disabled: isLoading.value,
                  loading: isPrinting.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.downloadCode")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttonConfigs.value, (button, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (
                button.show.includes(verificationDetails.value.status) ||
                button.show.length === 0
              )
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: button.type,
                      class: "ms-5",
                      onClick: button.action
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(button.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["type", "onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createVNode(ModalMenu)
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(ScaleLoader, { color: '#ffc730' })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_form, {
                  ref_key: "ruleFormRef",
                  ref: ruleFormRef,
                  class: "pb-10",
                  model: formData.value,
                  rules: rules,
                  "hide-required-asterisk": true,
                  "label-width": "auto",
                  "label-position": "top",
                  style: {"z-index":"9"}
                }, {
                  default: _withCtx(() => [
                    (currentTab.value === VerificationTab.Info)
                      ? (_openBlock(), _createBlock(JpInfo, { key: 0 }))
                      : _createCommentVNode("", true),
                    (currentTab.value === VerificationTab.Financial)
                      ? (_openBlock(), _createBlock(JpFinancial, { key: 1 }))
                      : _createCommentVNode("", true),
                    (currentTab.value === VerificationTab.Agreement)
                      ? (_openBlock(), _createBlock(JpAgreement, { key: 2 }))
                      : _createCommentVNode("", true),
                    (currentTab.value === VerificationTab.Review)
                      ? (_openBlock(), _createBlock(JpReview, { key: 3 }))
                      : _createCommentVNode("", true),
                    (currentTab.value === VerificationTab.PDF)
                      ? (_openBlock(), _createBlock(JpPdf, { key: 4 }))
                      : _createCommentVNode("", true),
                    (currentTab.value === VerificationTab.VerificationCode)
                      ? (_openBlock(), _createBlock(JpVerificationCode, { key: 5 }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(ShowMoveModal, {
      ref_key: "moveModalRef",
      ref: moveModalRef,
      onUserMoved: _cache[4] || (_cache[4] = ($event: any) => (emits('user-moved')))
    }, null, 512)
  ], 64))
}
}

})